export class ConnectGcpOrganizationRequest {
    'organizationId';
    'managementServiceAccountId';
    'excludeProjectPatterns';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementServiceAccountId",
            "baseName": "managementServiceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludeProjectPatterns",
            "baseName": "excludeProjectPatterns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGcpOrganizationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
